<template>
  <div>
    <widget-loader-component :key="pUniqueKey" />
  </div>
</template>

<script>
  import WidgetLoaderComponent from './widget-loader-component';
  import store from '../store';

  export default {
    name: 'HomeComponent',
    components: {
      WidgetLoaderComponent,
    },
    computed: {
      /**
       * Force rerender on player change
       */
      pUniqueKey() {
        return store.state.UserModule.pUniqueKey;
      }
    }
  };
</script>

<style scoped>
</style>
